
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Pageable } from "app/models/pageable-mode";
import { BehaviorSubject, Observable } from "rxjs";

export abstract class AbPessoa extends AppService {
  abstract pageablePessoaUnidade: Pageable;
  abstract filterPessoaUnidade: AppFilter;
  abstract pessoaId: BehaviorSubject<boolean>;
  abstract getAllPerfis();
  abstract getAllPessoas(filter: AppFilter);
  abstract getAllPessoasV2(filter: AppFilter);
  abstract getAllPessoasNome(filter: AppFilter);
  abstract getAllPessoasDtoAtivasNome(filter: AppFilter);
  abstract getAllPessoaUnidade(filter: AppFilter);
  abstract desativarPessoa(id: number);
  abstract getPessoaLogada();
  abstract getPessoaDtoLogada();
  abstract getPessoaUnidade();
  abstract salvar(pessoa): Observable<any>;
  abstract getPessoa(id: number): Observable<any>;
  abstract getPessoaById(id: number, isSigma: boolean): Observable<any>;
  abstract getPessoasdaUnidade(filter: AppFilter);
  abstract getAllByUnidadeId(unidadeId: number);
  abstract getRegistarAcessoPessoaLogada();
  abstract getAllPessoasAtivasPortariaDto(filterType: string, typed?: string);
  abstract vincularPessoas(pessoasId: Array<number>, unidadeId): Observable<any>;
  abstract desvincularPessoas(pessoaId, unidadeId): Observable<any>;
  abstract getAllPessoaUnidadeAtivasByUnidadeId(filter: AppFilter);
  abstract getAllPessoaUnidadeAtivasByPessoaId(pessoaId: number);
  abstract checkVinculoUnidadePessoaDocumento(unidadeId, documento: string);
  abstract getPessoasCredenciais(): Promise<any>;
  abstract getIdPessoaIntegrador(): Observable<any>;
  abstract getFoto(id: number): Observable<Blob>;
}
